var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  }

  return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
var s = {
  root: 'easy-print-NoPrint-root-1A10',
  _force: 'easy-print-NoPrint-_force-1-C_'
};

require('load-styles')('/*  imported from NoPrint.css  */\n\n@media print {\n  .easy-print-NoPrint-root-1A10 {\n    visibility: hidden;\n  }\n  .easy-print-NoPrint-_force-1-C_ {\n    display: none;\n  }\n}\n');

var propTypes = {
  force: PropTypes.bool,
  children: PropTypes.node.isRequired
};

var NoPrint = function (_React$PureComponent) {
  _inherits(NoPrint, _React$PureComponent);

  function NoPrint() {
    _classCallCheck(this, NoPrint);

    return _possibleConstructorReturn(this, (NoPrint.__proto__ || Object.getPrototypeOf(NoPrint)).apply(this, arguments));
  }

  _createClass(NoPrint, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          force = _props.force;
      var force_ = force ? s._force : '';
      return React.createElement('div', {
        className: s.root + ' ' + force_
      }, children);
    }
  }]);

  return NoPrint;
}(React.PureComponent);

export default NoPrint;